import script from "./MultipleChoiceQuestion.vue?vue&type=script&setup=true&lang=js"
export * from "./MultipleChoiceQuestion.vue?vue&type=script&setup=true&lang=js"

import "./MultipleChoiceQuestion.vue?vue&type=style&index=0&id=6955842e&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/tests-frontend/tests-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6955842e"]])

export default __exports__